import React from 'react';
import { usePresence } from '@/hooks/usePresence';
import { cn } from '@/lib/utils';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { ErrorBoundary } from '@/components/common/ErrorBoundary';

export function PresenceAvatars() {
  const { onlineUsers, isConnected } = usePresence();

  // Don't show anything if not connected or only one user online
  if (!isConnected || onlineUsers.length <= 1) return null;

  return (
    <ErrorBoundary label="Presence Indicators">
      <TooltipProvider>
        <div className="flex items-center -space-x-2 mr-4">
          {onlineUsers.map((user) => (
            <Tooltip key={user.id}>
              <TooltipTrigger asChild>
                <div className={cn(
                  "h-7 w-7 rounded-full border-2 border-[#0a0a0c] flex items-center justify-center transition-all hover:scale-110 cursor-default ring-1 ring-white/5",
                  user.color
                )}>
                  <span className="text-[10px] font-semibold text-black">{user.initials}</span>
                </div>
              </TooltipTrigger>
              <TooltipContent className="bg-slate-900 border-border text-foreground text-[10px] font-semibold uppercase tracking-widest py-1.5 px-3">
                {user.name} (Online)
              </TooltipContent>
            </Tooltip>
          ))}
        </div>
      </TooltipProvider>
    </ErrorBoundary>
  );
}
